import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BudgetResource, _CompetitionType, _Entailment } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    isDisabled?: boolean
}

export const BudgetResourceEditor = ({ idSelector, onChange, label, isDisabled }: Props) => {

    const competitionType = useDataBean(_BudgetResource)
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(idSelector ?? null);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector)
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }


    const getLista = () => {

        competitionType.instance.getBudgetResourceCatalog(null).then(
            (resp: any) => {
                if (resp) {

                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Tipos de Recurso"}</label>
            <select disabled={isDisabled} className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value="">...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBudgetResource} >{`${item.DataBeanProperties.Code ?? ""} - ${item.DataBeanProperties.Name ?? ""}`}</option>
                        )
                    })
                }
            </select>
        </>
    )
}